var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26781 15.8405C8.20144 15.8405 8.96532 15.0905 8.96532 14.1738V5.84049C8.96532 4.92383 8.20144 4.17383 7.26781 4.17383C6.33419 4.17383 5.57031 4.92383 5.57031 5.84049V14.1738C5.57031 15.0905 6.33419 15.8405 7.26781 15.8405ZM12.3603 5.84049V14.1738C12.3603 15.0905 13.1242 15.8405 14.0578 15.8405C14.9914 15.8405 15.7553 15.0905 15.7553 14.1738V5.84049C15.7553 4.92383 14.9914 4.17383 14.0578 4.17383C13.1242 4.17383 12.3603 4.92383 12.3603 5.84049Z",
    fill: "#8F4300",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.ef4bb70c17d70f8a4b779baa43df922d.svg";
export { ForwardRef as ReactComponent };